/* ============================================================
   Custom Product Builder — custom store scripts
   Rewritten: null-safe, no artificial delays,
   click-and-hold zoom (desktop only)
   ============================================================ */

/* ---------------- Scroll lock ---------------- */

function preventScroll(event) {
  event.preventDefault();
}

function disableScroll() {
  window.addEventListener('scroll', preventScroll, { passive: false });
  window.addEventListener('wheel', preventScroll, { passive: false });
  window.addEventListener('touchmove', preventScroll, { passive: false });
}

function enableScroll() {
  window.removeEventListener('scroll', preventScroll);
  window.removeEventListener('wheel', preventScroll);
  window.removeEventListener('touchmove', preventScroll);
}

window.history.scrollRestoration = 'manual';

document.addEventListener('DOMContentLoaded', function () {
  window.scrollTo(0, 0);
  disableScroll();
});

/* Safety net: whatever happens, the page is scrollable after 6s */
setTimeout(enableScroll, 6000);

/* Unlock as soon as the builder is actually on screen */
document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function () {
  enableScroll();
});

/* ---------------- Tooltips ---------------- */

function hideTooltip() {
  var tooltip = document.querySelector('.Polaris-PositionedOverlay');
  if (tooltip) tooltip.style.display = 'none';
}

/* One listener with capture catches scrolling of the page
   and of any inner panel, so no per-element listeners are needed */
document.addEventListener('scroll', hideTooltip, true);

/* ---------------- Keep scroll position when picking a text option ---------------- */

document.addEventListener('click', function (event) {
  if (!event.target.closest || !event.target.closest('.cpb-option-type-text')) return;

  var y = window.scrollY;
  var frames = 0;

  (function restore() {
    window.scrollTo(0, y);
    frames += 1;
    if (frames < 30) requestAnimationFrame(restore);
  })();
});

/* ---------------- Mobile layout padding ---------------- */

function applyMobilePadding() {
  if (window.innerWidth >= 600) return;

  var previewContainer = document.querySelector('.cpb-preview-container');
  var panelContainer = document.querySelector('.cpb-panels-container');
  var previewLayers = document.querySelector('.cpb-preview-layers');
  if (!previewContainer || !panelContainer || !previewLayers) return;

  panelContainer.style.removeProperty('--padding');
  previewLayers.style.removeProperty('--padding');

  var h = previewContainer.clientHeight;
  if (!h) return;

  panelContainer.style.setProperty('--padding', (h - 40) + 'px');
  previewLayers.style.setProperty('--padding', (h - 170) + 'px');
}

/* ---------------- Builder setup after mount ---------------- */

function removeScroll() {
  document.querySelectorAll('.cpb-panels-tabs-button span').forEach(function (btn) {
    btn.innerText = btn.textContent.split(' ')[0];
  });

  var price = document.querySelector('.cpb-product-actions-first');
  var addToCartBtn = document.querySelector('.cpb-add-to-cart-button');

  /* Wholesale: hide price and gate add-to-cart behind login */
  if (price && addToCartBtn && window.Shopify && !window.Shopify.customer) {
    var loginBtn = addToCartBtn.cloneNode(true);
    price.textContent = 'Login to view price';
    price.classList.add('login');
    loginBtn.textContent = 'LOGIN TO ADD TO CART';
    addToCartBtn.parentNode.replaceChild(loginBtn, addToCartBtn);
    loginBtn.addEventListener('click', function () {
      window.location.href = '/account/login';
    });
  }

  applyMobilePadding();
  setTimeout(applyMobilePadding, 400);
}

var lastWidth = window.innerWidth;
window.addEventListener('resize', function () {
  if (window.innerWidth === lastWidth) return;
  lastWidth = window.innerWidth;
  applyMobilePadding();
});

/* ---------------- Show chosen option inside the category title ---------------- */

function displaySelectedOptionsInTheTitle() {
  if (typeof CPB === 'undefined' || !CPB.getStore) return;

  var Product = CPB.getStore().getState().Product;
  if (!Product || !Product.layers) return;

  Product.layers.forEach(function (layer) {
    var layerDomElement = document.querySelector('.cpb-category-' + layer.category);
    if (!layerDomElement) return;

    var customTitle = layerDomElement.querySelector('.cpb-custom-title');
    if (customTitle) customTitle.remove();

    var title = layerDomElement.querySelector('.cpb-category-title__inner span');
    if (!title) return;

    var panel = Product.panels.find(function (p) { return p.id === layer.panel; });
    if (!panel) return;

    var category = panel.categories.find(function (cat) { return cat.id === layer.category; });
    if (!category) return;

    var option = category.options.find(function (opt) { return opt.id === layer.option; });
    if (!option || !option.option || !option.option.data) return;

    var newElement = document.createElement('span');
    newElement.classList.add('cpb-custom-title');
    newElement.textContent = ': ' + option.option.data.label;
    title.after(newElement);
  });
}

/* ---------------- CPB lifecycle ---------------- */

document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function () {
  displaySelectedOptionsInTheTitle();
  removeScroll();
});

/* Registered once, at top level — not re-registered on every mount */
document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', function () {
  displaySelectedOptionsInTheTitle();
});

document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', function () {
  displaySelectedOptionsInTheTitle();
});

/* ---------------- Add to cart → open cart drawer ---------------- */

document.addEventListener('cpb-add-to-cart', function () {
  document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  drawer.addEventListener('cart-drawer:refreshed', function () {
    drawer.show();
  }, { once: true });
});

/* ---------------- Click-and-hold zoom (desktop only) ----------------
   Hold the left mouse button on the image to zoom in,
   move the mouse to pan around, release to zoom back out.
   Uses event delegation, so new slides work automatically.
------------------------------------------------------------------- */

var ZOOM_MIN_WIDTH = 1000;
var zoomContainer = null;
var zoomEvent = null;
var zoomFrame = null;

function applyZoomOrigin() {
  zoomFrame = null;
  if (!zoomContainer || !zoomEvent) return;

  var rect = zoomContainer.getBoundingClientRect();
  if (!rect.width || !rect.height) return;

  var x = ((zoomEvent.clientX - rect.left) / rect.width) * 100;
  var y = ((zoomEvent.clientY - rect.top) / rect.height) * 100;

  x = Math.max(0, Math.min(100, x));
  y = Math.max(0, Math.min(100, y));

  var target = zoomContainer.querySelector('.cpb-render-wrapper.cpb-current-view, .cpb-render-img');
  if (target) target.style.transformOrigin = x + '% ' + y + '%';
}

function queueZoomOrigin(e) {
  zoomEvent = e;
  if (zoomFrame === null) zoomFrame = requestAnimationFrame(applyZoomOrigin);
}

function endZoom() {
  if (!zoomContainer) return;
  zoomContainer.classList.remove('cpb-zoom-active');
  zoomContainer = null;
  zoomEvent = null;
}

document.addEventListener('mousedown', function (e) {
  if (e.button !== 0) return;
  if (window.cpbZoomEnabled === false) return;
  if (window.innerWidth < ZOOM_MIN_WIDTH) return;
  if (!e.target.closest) return;

  var container = e.target.closest('.cpb-swiper-main');
  if (!container) return;

  zoomContainer = container;
  queueZoomOrigin(e);
  container.classList.add('cpb-zoom-active');
  e.preventDefault(); /* stop the browser from starting an image drag */
});

document.addEventListener('mousemove', function (e) {
  if (!zoomContainer) return;
  queueZoomOrigin(e);
});

document.addEventListener('mouseup', endZoom);
document.addEventListener('mouseleave', endZoom);
window.addEventListener('blur', endZoom);

document.addEventListener('dragstart', function (e) {
  if (e.target.closest && e.target.closest('.cpb-swiper-main')) e.preventDefault();
});
